import { specsDefault } from './moovex';
import { specsTaxleco } from './taxleco';

export default [specsDefault, specsTaxleco];
